/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DiscrepanciesUnit {
  Piece = 'PIECE',
  QuarterDisplay = 'QUARTER_DISPLAY',
  HalfDisplay = 'HALF_DISPLAY',
  Carton = 'CARTON',
  Pallet = 'PALLET',
  Colli = 'COLLI',
  Tray = 'TRAY',
  Kilogram = 'KILOGRAM',
  Gram = 'GRAM',
  Ton = 'TON',
  PartialPallet = 'PARTIAL_PALLET',
  Package = 'PACKAGE',
  SetBundle = 'SET_BUNDLE',
  Batch = 'BATCH',
  Liter = 'LITER',
  CubicMeter = 'CUBIC_METER',
  LinearMeter = 'LINEAR_METER',
  ConsumerUnit = 'CONSUMER_UNIT',
  Canister = 'CANISTER',
  EuroPallet = 'EURO_PALLET',
  DdpHalfPallet = 'DDP_HALF_PALLET',
  H1Pallet = 'H1_PALLET',
  IndustrialPallet = 'INDUSTRIAL_PALLET',
  Chep11 = 'CHEP_1_1',
  Chep12 = 'CHEP_1_2',
  Chep14 = 'CHEP_1_4',
  ChepPlasticEuroPallet = 'CHEP_PLASTIC_EURO_PALLET',
  Lpr11 = 'LPR_1_1',
  Lpr12 = 'LPR_1_2',
  Lpr14 = 'LPR_1_4',
  Ipp11 = 'IPP_1_1',
  Ipp12 = 'IPP_1_2',
  Ipp14 = 'IPP_1_4',
  Gitterbox = 'GITTERBOX',
  DisposablePallet = 'DISPOSABLE_PALLET',
  E1Box = 'E1_BOX',
  E2Box = 'E2_BOX',
  Wk1Box = 'WK1_BOX',
  Wk2Box = 'WK2_BOX',
  Arpack12 = 'ARPACK_1_2',
  PanelPallet = 'PANEL_PALLET',
  PlasticHalfPallet = 'PLASTIC_HALF_PALLET',
  BrunnenPallet = 'BRUNNEN_PALLET',
  ChipboardPallet = 'CHIPBOARD_PALLET',
  CcContainer = 'CC_CONTAINER',
  CcTrolley = 'CC_TROLLEY',
  CcBars = 'CC_BARS',
  CcShelves = 'CC_SHELVES',
  CcRiser = 'CC_RISER',
  EcContainer = 'EC_CONTAINER',
  EcTrolley = 'EC_TROLLEY',
  EcBar = 'EC_BAR',
  EcShelves = 'EC_SHELVES',
  Floritray = 'FLORITRAY',
  Preturn11 = 'PRETURN_1_1',
  Preturn12 = 'PRETURN_1_2',
  KdpPlasticDusseldorfPallet = 'KDP_PLASTIC_DUSSELDORF_PALLET',
  IfcoBoxBll4314 = 'IFCO_BOX_BLL_4314',
  IfcoBoxBll4320 = 'IFCO_BOX_BLL_4320',
  IfcoBoxBll6408 = 'IFCO_BOX_BLL_6408',
  IfcoBoxBll6410 = 'IFCO_BOX_BLL_6410',
  IfcoBoxBll6413 = 'IFCO_BOX_BLL_6413',
  IfcoBoxBll6416 = 'IFCO_BOX_BLL_6416',
  IfcoBoxBll6418 = 'IFCO_BOX_BLL_6418',
  IfcoBoxBll6420 = 'IFCO_BOX_BLL_6420',
  IfcoBoxBll6424 = 'IFCO_BOX_BLL_6424',
  Other = 'OTHER'
}
